import React, { useRef } from 'react'
import SbEditable from 'storyblok-react'
import { HotspotProps } from './Hotspot.d'
import Laptop from './Laptop'
import useResponsive from '@/hooks/useResponsive'

interface Props {
  blok: StoryblokComponent & HotspotProps
}

export const Hotspot = ({ blok }: Props) => {
  const marginTopClass = blok.marginTop ? `${blok.marginTop}px` : ''
  const marginBottomClass = blok.marginBottom ? `${blok.marginBottom}px` : ''
  const { isMobile, isTablet } = useResponsive()

  const containerHeight = isMobile 
    ? 'h-[30%] pt-[95%]' 
    : isTablet 
    ? 'h-[80vh] pt-[35%]' 
    : 'h-[10%] pt-[30%]'

  return (
    <div
      data-testdata="hotspot-block"
      className={`font-display relative ${containerHeight} flex flex-col items-center justify-start mb-[-300px] lg:mb-[-490px]`}
      style={{
        backgroundImage: blok.has_background ? `url(${blok.background_image})` : 'none',
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        marginTop: marginTopClass,
        marginBottom: marginBottomClass,
      }}
    >
      {/** @ts-ignore: Storyblok typing issue with children **/}
      <SbEditable content={blok} key={blok._uid}>
        <Laptop
          background={blok.has_background ? blok.background_image : null}
          width={isMobile ? 300 : isTablet ? 400 : 800}
          image={blok.hotspot_image}
          hotspots={blok.items}
          className="mx-auto"
          label={blok.label}
          heading={blok.heading}
          content={blok.content}
          cta_text={blok.cta_text}
          cta_link={blok.cta_link}
        />
      </SbEditable>
    </div>
  )
}

Hotspot.displayName = 'Hotspot Block'